import { Routes, Route } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { AuthProvider } from './contexts/AuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { CustomerIntelligenceProvider } from './contexts/CustomerIntelligenceContext';
import { Layout } from './components/layout/Layout';
import { AdminLayout } from './components/admin';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import {
  HomePage,
  CategoryPage,
  ProductDetailPage,
  SearchResultsPage,
  CartPage,
  CheckoutPage,
  OrderConfirmationPage,
  AccountPage,
  NotFoundPage,
  LoginPage,
  RegisterPage,
  BlogPage,
  BlogPostPage,
  HelpCenterPage,
  ShippingPolicyPage,
  ReturnsPage,
  TermsPage,
  PrivacyPage,
  ForgotPasswordPage,
  ResetPasswordPage,
} from './pages';
import {
  AdminLoginPage,
  AdminDashboardPage,
  AdminAnalyticsPage,
  AdminSEOPage,
  AdminHeroSlidesPage,
  AdminFeaturesPage,
  AdminUsersPage,
  AdminAISettingsPage,
} from './pages/admin';

export default function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <CustomerIntelligenceProvider>
          <CartProvider>
            <Layout>
          <Routes>
            {/* Home */}
            <Route path="/" element={<HomePage />} />

            {/* Auth routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/registro" element={<RegisterPage />} />

            {/* Categories */}
            <Route path="/perros" element={<CategoryPage />} />
            <Route path="/gatos" element={<CategoryPage />} />
            <Route path="/prendas" element={<CategoryPage />} />
            <Route path="/placas" element={<CategoryPage />} />
            <Route path="/farmacia" element={<CategoryPage />} />
            <Route path="/outlet" element={<CategoryPage />} />

            {/* Product detail */}
            <Route path="/producto/:id" element={<ProductDetailPage />} />

            {/* Search */}
            <Route path="/buscar" element={<SearchResultsPage />} />

            {/* Cart and checkout */}
            <Route path="/carrito" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />

            {/* Protected routes - require authentication */}
            <Route
              path="/cuenta"
              element={
                <ProtectedRoute>
                  <AccountPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pedidos"
              element={
                <ProtectedRoute>
                  <AccountPage />
                </ProtectedRoute>
              }
            />
            <Route path="/pedidos/confirmacion" element={<OrderConfirmationPage />} />

            {/* Blog */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />

            {/* Static pages - implemented */}
            <Route path="/ayuda" element={<HelpCenterPage />} />
            <Route path="/envios" element={<ShippingPolicyPage />} />
            <Route path="/devoluciones" element={<ReturnsPage />} />
            <Route path="/terminos" element={<TermsPage />} />
            <Route path="/privacidad" element={<PrivacyPage />} />
            <Route path="/olvide-contrasena" element={<ForgotPasswordPage />} />
            <Route path="/restablecer-contrasena" element={<ResetPasswordPage />} />

            {/* 404 for store pages */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
            </Layout>
          </CartProvider>
        </CustomerIntelligenceProvider>
      </AuthProvider>

      {/* Admin Routes - Outside main layout */}
      <AdminAuthProvider>
        <Routes>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin/*"
            element={
              <AdminLayout>
                <Routes>
                  <Route path="/" element={<AdminDashboardPage />} />
                  <Route path="/analytics" element={<AdminAnalyticsPage />} />
                  <Route path="/seo" element={<AdminSEOPage />} />
                  <Route path="/hero-slides" element={<AdminHeroSlidesPage />} />
                  <Route path="/features" element={<AdminFeaturesPage />} />
                  <Route path="/users" element={<AdminUsersPage />} />
                  <Route path="/ai" element={<AdminAISettingsPage />} />
                </Routes>
              </AdminLayout>
            }
          />
        </Routes>
      </AdminAuthProvider>
    </SettingsProvider>
  );
}


